import { configureStore } from '@reduxjs/toolkit'
import authReducer from './slices/authSlice'
import projectReducer from './slices/projectSlice'
import issueReducer from './slices/issueSlice'
import commentReducer from './slices/commentSlice'
import activityReducer from './slices/activitySlice'
import boardStatusReducer from './slices/boardStatusSlice'
import labelReducer from './slices/labelSlice'
import ragChatReducer from './slices/ragChatSlice'
import formTemplatesReducer from './slices/formTemplateSlice'
import formInstancesReducer from './slices/formInstanceSlice'
import calendarReducer from './slices/calendarSlice'
import financeReducer from './slices/financeSlice'

export const store = configureStore({
  reducer: {
    auth: authReducer,
    project: projectReducer,
    issue: issueReducer,
    comment: commentReducer,
    activity: activityReducer,
    boardStatus: boardStatusReducer,
    label: labelReducer,
    ragChat: ragChatReducer,
    formTemplates: formTemplatesReducer,
    formInstances: formInstancesReducer,
    calendar: calendarReducer,
    finance: financeReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST'],
      },
    }),
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
